import React from "react";
import {Column} from "../../ui/spectre/grid";
import {Button, ButtonTypes} from "../../ui/spectre/buttons";
import {Icon} from "../../ui/spectre/icon";

export default function GroupMember({ accountName, roleName, canRemove, canEdit }) {
    return <>
        <Column sizes={[4]}>{accountName}</Column>
        <Column sizes={[4]}>{roleName}</Column>
        <Column sizes={[2]}>
            {canEdit && <Button buttonTypes={[ButtonTypes.small]}><Icon type={'edit'} /></Button>}
            {canRemove && <Button buttonTypes={[ButtonTypes.small]}><Icon type={'delete'} /></Button>}
        </Column>
    </>
}
